import { ReactNode } from "react";

export default function StepLayout({
  title = "Title",
  description = "Description",
  mainArea,
  extraArea,
  plainChildren,
  children,
}) {
  const isPlainChildren =
    typeof plainChildren == "boolean" && plainChildren == true;
  return (
    <div className="w-full text-brand-navy">
      <StepLayoutHeader title={title} description={description} />

      <div className="mt-5">
        {isPlainChildren && children}
        {!isPlainChildren && (
          <section className="flex w-full flex-col space-y-4 rounded-xl bg-surface p-4">
            {children ? (
              children
            ) : (
              <StepStyleSection>{mainArea}</StepStyleSection>
            )}
            {!!extraArea && <StepLayoutFooter>{extraArea}</StepLayoutFooter>}
          </section>
        )}
      </div>
    </div>
  );
}

export function StepLayoutRoot({ children }) {
  return children;
}

export function StepLayoutHeader({
  title = "Title",
  description = "Description",
  className,
}) {
  return (
    <div className={`${className}`}>
      <h3 className="text-base font-bold text-brand-navy">{title}</h3>
      <p className="mt-1 text-sm text-muted-foreground">{description}</p>
    </div>
  );
}

export function StepLayoutBody({ isPlain, children }) {
  return (
    <div
      className={`${!isPlain && "bg-surface"} space-y-4 rounded-xl p-2 md:p-4`}
    >
      {children}
    </div>
  );
}

export function StepLayoutFooter({ className, children }) {
  return (
    <div className={`border-t pt-4 ${className ?? ""}`}>{children}</div>
  );
}

export function StepStyleSection({ children, isInvalid }) {
  return (
    <div
      className={`rounded-xl border bg-card p-3 md:p-4 ${
        isInvalid ? "border-red-300" : ""
      }`}
    >
      {children}
    </div>
  );
}
